<template>
  <ul class="steps">
        <li class="steps__element " :class="stepClasses(1)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 1)?'steps__link--active':''" @click.prevent="goToStep(1)">Basic information</a>
        </li>

        <li class="steps__element " :class="stepClasses(2)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 2)?'steps__link--active':''" @click.prevent="goToStep(2)">Company profile</a>
        </li>

        <li class="steps__element" :class="stepClasses(3)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 3)?'steps__link--active':''" @click.prevent="goToStep(3)">Search Optimisation</a>
        </li>
        <li class="steps__element" :class="stepClasses(4)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 4)?'steps__link--active':''" @click.prevent="goToStep(4)">Category</a>
        </li>

        <li v-if="getComponentType !== 'logged'" class="steps__element" :class="stepClasses(5)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 5)?'steps__link--active':''" @click.prevent="goToStep(5)">Your Profile</a>
        </li>
        <li v-if="getComponentType !== 'logged'" class="steps__element" :class="stepClasses(6)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 6)?'steps__link--active':''" @click.prevent="goToStep(6)">Email confirmation</a>
        </li>
        <li v-if="getComponentType !== 'logged'" class="steps__element" :class="stepClasses(7)">
            <i class="icon-check"></i>
            <a href="#" class="steps__link " :class="(getStep == 7)?'steps__link--active':''" @click.prevent="goToStep(7)">Listing Preview</a>
        </li>
    </ul>
</template>

<script>

import {mapGetters, mapActions} from 'vuex';

export default {

computed:{
    ...mapGetters([
        'getStep',
        'getComponentType',
    ]),
},
methods:{
    ...mapActions([
        'changeStep'
    ]),
    stepClasses(step) {
        let classes = '';
        if (this.getStep > step) classes += 'steps__element--passed ';
        if (this.getStep == step) classes += 'steps__element--active';
        return classes;
    },
    goToStep(step){
        this.changeStep(step);
    }
}
}
</script>
